import template from './shiptype.all.html';
import controller from './shiptype.all.controller';
import './shiptype.all.scss';

let shiptypeallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default shiptypeallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/all/shiptype.all.component.js